import { render, staticRenderFns } from "./SharedLinkList.vue?vue&type=template&id=794f898d&scoped=true"
import script from "./SharedLinkList.vue?vue&type=script&lang=ts"
export * from "./SharedLinkList.vue?vue&type=script&lang=ts"
import style0 from "./SharedLinkList.vue?vue&type=style&index=0&id=794f898d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794f898d",
  null
  
)

export default component.exports